import React, { useEffect, useState } from "react";
import { SelectInputWTitle } from "./SelectInputWTitle";
import { Loading } from "../Loading";
import { GetDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import { LoadingColor } from "../LoadingColor";


export const CitiesShowByCode = ({
    code,
    lan= false,
    Country_Id = 1,
}) => {
    const [loading, setLoading] = useState(false);
    const [data, setDeta] = useState([]);
    // check subsystem
    useEffect(() => {
        if(!loading){
            getData();
        }
    }, [])
    useEffect(() => {
        getData();
    }, [Country_Id])
    const getData = async () => {
        setLoading(true);
        let params = new URLSearchParams();
        params.append("Country_Id", Country_Id);
        let res = await GetDataPromise(`${apiMain}/api/v1/setting/city/select?${params.toString()}`);
        let parsed = JSON.parse(res);
        if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
            const collator = new Intl.Collator('fa'); 
            let sorted = parsed.data.sort((a, b) => {
                return collator.compare(a.City_Name, b.City_Name);
            })
          setDeta(sorted);
          setLoading(false);
          return;
        }
        setLoading(false);
    }
    if(loading){
        return (
            <LoadingColor/>
        )
    }
    let options = data.map((v) => {
        return {
            value: v.City_Id,
            name: (lan) ? v.City_EnName : v.City_Name
        }
    })
    let find = options.findIndex((v) => parseInt(v.value) === parseInt(code));
    if(find !== -1){
        return " " + options[find].name + " ";
    }
    return ""
};